<div class="legal-container">
      <div class="header-left">
          <button type="button" class="back-btn" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            <span>Retour à l'accueil</span>
          </button>
        </div>
    <header class="legal-header">
        <div class="logo-container">
            <img src="assets/images/logo-2.png" alt="YokaStar Logo">
        </div>
        <h1>Politique de Confidentialité & RGPD</h1>
        <p class="subtitle">Dernière mise à jour : {{ currentDate | date: 'longDate' }}</p>
    </header>

    <main class="legal-content">
        <section class="intro-section">
            <p>
                Chez <strong>YokaStar</strong>, nous prenons la protection de vos données personnelles très au sérieux.
                Cette politique explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre plateforme.
            </p>
        </section>

        <section class="data-section">
            <h2><i class="fas fa-database icon"></i> Données que nous collectons</h2>
            <div class="grid-layout">
                <div class="data-card">
                    <h3>Informations de compte</h3>
                    <ul>
                        <li>Nom, prénom</li>
                        <li>Adresse email</li>
                        <li>Photo de profil</li>
                        <li>Numero de téléphone</li>
                    </ul>
                </div>
                <div class="data-card">
                    <h3>Données de paiement</h3>
                    <ul>
                        <li>Informations de facturation</li>
                        <li>Historique des transactions</li>
                        <li>Méthodes de paiement enregistrées</li>
                    </ul>
                </div>
                <div class="data-card">
                    <h3>Activité sur la plateforme</h3>
                    <ul>
                        <li>Demandes de vidéos</li>
                        <li>Messages échangés</li>
                        <li>Préférences et favoris</li>
                        <li>Données techniques (adresse IP, appareil)</li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="usage-section">
            <h2><i class="fas fa-cogs icon"></i> Comment nous utilisons vos données</h2>
            <div class="grid-layout">
                <div class="usage-item">
                    <i class="fas fa-video"></i>
                    <h3>Fournir nos services</h3>
                    <p>Permettre la commande et la livraison de vidéos personnalisées</p>
                </div>
                <div class="usage-item">
                    <i class="fas fa-lock"></i>
                    <h3>Sécurité</h3>
                    <p>Protéger votre compte et prévenir les fraudes</p>
                </div>
                <div class="usage-item">
                    <i class="fas fa-bell"></i>
                    <h3>Notifications</h3>
                    <p>Vous informer sur l'état de vos commandes</p>
                </div>
                <div class="usage-item">
                    <i class="fas fa-chart-line"></i>
                    <h3>Amélioration</h3>
                    <p>Analyser l'usage pour améliorer notre plateforme</p>
                </div>
            </div>
        </section>

        <section class="rights-section">
            <h2><i class="fas fa-gavel icon"></i> Vos droits RGPD</h2>
            <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
            </p>
            <div class="grid-layout">
                <div class="right-item">
                    <span class="right-number">1</span>
                    <div>
                        <h3>Droit d'accès</h3>
                        <p>Demander une copie de vos données personnelles</p>
                    </div>
                </div>
                <div class="right-item">
                    <span class="right-number">2</span>
                    <div>
                        <h3>Droit de rectification</h3>
                        <p>Corriger des informations inexactes</p>
                    </div>
                </div>
                <div class="right-item">
                    <span class="right-number">3</span>
                    <div>
                        <h3>Droit à l'effacement</h3>
                        <p>Demander la suppression de vos données</p>
                    </div>
                </div>
                <div class="right-item">
                    <span class="right-number">4</span>
                    <div>
                        <h3>Droit d'opposition</h3>
                        <p>S'opposer au traitement de vos données</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="contact-section">
            <h2><i class="fas fa-envelope icon"></i> Contact</h2>
            <p>
                Pour toute question concernant cette politique ou pour exercer vos droits RGPD, veuillez contacter notre Délégué à la Protection des Données :
            </p>
            <div class="contact-card">
                <p><strong>Email : </strong> <a href="mailto:privacy&#64;yokastar.com">privacy&#64;yokastar.com</a></p>
                <p><strong>Adresse :</strong> 11 Bis, Av. Okapi; Q/Congo C/Ngaliema Kinshasa/ R.D.Congo</p>
            </div>
        </section>
    </main>

    <app-legal-footer></app-legal-footer>
</div>